/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { useTranslation } from "react-i18next";

const ESConstraintMessage = () => {
	const { t } = useTranslation();
	return (
		<div className="bg-blue-50 border border-blue-100 rounded-3xl p-6 flex gap-4">
			<div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center shrink-0 shadow-sm">
				<span className="material-symbols-outlined text-blue-500">
					info
				</span>
			</div>
			<div className="space-y-2">
				<p className="text-xs font-bold text-blue-800 leading-relaxed">
					{t(
						"postAutoclaveProcess.emptySterilization.InventoryWillBeUpdated",
					)}
				</p>
				<p className="text-[11px] text-blue-600 font-medium leading-relaxed">
					{t(
						"postAutoclaveProcess.emptySterilization.OnlyPlatesThatPassed",
					)}
				</p>
			</div>
		</div>
	);
};

export default ESConstraintMessage;
